import type { PublicSlotKey } from '@/apilib';
import type { SwitchLayoutApi } from './switchLayoutApi';

export const SwitchLayoutApiKey: PublicSlotKey<SwitchLayoutApi> = {
  name: 'SwitchLayoutApi',
  public: true,
};
